import initiateVueComponents from "../../../initiateVueComponents";

initiateVueComponents(require.context("./", true, /[A-Z]\w+\.(vue)$/));
